import { ArrowUpRight, Check, ContactRound, FileText, Sparkles, Target } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { productConfig } from '@shared/config';
import { Progress } from '@/components/ui';

const scoreCards = [
  { key: 'cv', value: 82, icon: FileText, tone: 'blue' },
  { key: 'linkedin', value: 64, icon: ContactRound, tone: 'cyan' },
  { key: 'match', value: 78, icon: Target, tone: 'green' },
] as const;

export function DashboardMockup() {
  const { t } = useTranslation('landing');
  return (
    <div className="dashboard-mockup" aria-label={t('hero.previewTitle')}>
      <div className="mockup-windowbar">
        <div className="mockup-dots" aria-hidden="true">
          <span />
          <span />
          <span />
        </div>
        <span>{t('hero.previewLabel')}</span>
        <span className="mockup-live">
          <span /> {productConfig.brandName}
        </span>
      </div>
      <div className="mockup-body">
        <div className="mockup-sidebar" aria-hidden="true">
          <span className="mockup-logo" />
          {Array.from({ length: 6 }, (_, index) => (
            <span key={index} className={index === 0 ? 'active' : ''} />
          ))}
        </div>
        <div className="mockup-content">
          <div className="mockup-heading">
            <div>
              <small>{t('hero.previewLabel')}</small>
              <strong>{t('hero.previewTitle')}</strong>
            </div>
            <span className="mockup-avatar">AY</span>
          </div>
          <div className="mockup-score-grid">
            {scoreCards.map(({ key, value, icon: Icon, tone }) => (
              <article className={`mockup-score mockup-score--${tone}`} key={key}>
                <div className="mockup-score__icon">
                  <Icon size={15} />
                </div>
                <small>{t(`hero.scores.${key}`)}</small>
                <strong>
                  {value}
                  <span>{key === 'match' ? '%' : '/100'}</span>
                </strong>
                <Progress label={t(`hero.scores.${key}`)} value={value} />
              </article>
            ))}
          </div>
          <div className="mockup-lower">
            <article className="mockup-readiness">
              <div className="score-orbit" style={{ '--score': '72' } as React.CSSProperties}>
                <span>72%</span>
              </div>
              <div>
                <small>{t('hero.scores.interview')}</small>
                <strong>{t('hero.scores.ready')}</strong>
                <div className="mini-checks">
                  <span>
                    <Check size={11} /> HR
                  </span>
                  <span>
                    <Check size={11} /> CV
                  </span>
                </div>
              </div>
            </article>
            <article className="mockup-next-step">
              <div className="mockup-next-step__icon">
                <Sparkles size={16} />
              </div>
              <div>
                <small>{t('hero.recommended')}</small>
                <strong>{t('hero.recommendation')}</strong>
              </div>
              <ArrowUpRight size={17} />
            </article>
          </div>
          <div className="mockup-profile">
            <span>{t('hero.profile')}</span>
            <strong>74%</strong>
            <Progress label={t('hero.profile')} value={74} />
          </div>
        </div>
      </div>
    </div>
  );
}
